export function getUrlVars() {
  const vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (
    m,
    key,
    value,
  ) {
    vars[key] = value;
  });
  return vars;
}

export function setSearchParam(key, value) {
  if (!window.history.pushState) {
    return;
  }
  if (!key) {
    return;
  }

  let url = new URL(window.location.href);
  const params = new window.URLSearchParams(window.location.search);
  if (value === undefined || value === null) {
    params.delete(key);
  } else {
    value = value.toString();
    params.set(key, value);
  }

  url.search = params;
  url = url.toString();
  window.history.replaceState({ url }, null, url);
}
